module.exports = __webpack_public_path__ + "img/Autocolant TCE-01.6252b086.jpg";